import { LinkItemSchema } from '@/views/sports/components/CompetitionsMenu/styles/LinkItem.styles';

export const linkItemStyles: LinkItemSchema = {
  link: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    bg: 'beta.700',
    color: 'white',
    py: '2',
    pl: '3',
    pr: '2',
    mb: '1px',
    _last: {
      mb: 0,
    },
    _hover: {
      textDecoration: 'none',
    },
  },
  textCompetitionName: {
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxW: '140px',
  },
  textMatchCount: {
    color: 'white',
    px: '1',
    fontSize: '2xs',
  },
};
